import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import '../../../src/styles/Manual.css';
import { Button } from 'react-bootstrap';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { Link } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal'
import queryString from 'query-string';
import { appService } from '../../_services';
import ChapterModal from 'react-bootstrap/Modal'
import { authHeader, config } from '../../_helpers'
import DocumentMeta from 'react-document-meta';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import EmailModal from 'react-bootstrap/Modal'
import { AllManuals } from './AllManuals';
import { Redirect, Route } from 'react-router-dom';
import ReactGA from 'react-ga';
var fileName = "";
var DisplayClass = {
    display: 'block'
}
var Displaystyle = {
    display: 'inline-block'
}
var accordion = {
    backgroundColor: '#F6F6F6',
    padding: '10px 0px',
    borderLeft: '1px solid #CCCCCC',
    borderRight: '1px solid #CCCCCC',
    borderTop: '1px solid #CCCCCC',
    zindex: '9999'
}
var AccordionTitle = {
    color: '#474747',
    fontSize: '18px',
    paddingLeft: '2%'
}

var Marginset = {
    paddingTop: '1%',
    marginBottom: '1%'
}



let useragent = navigator.userAgent;
let url = '', params = '', parameters = '', options = '', currency = '', count = 0, open = false, ProductId = '', Emailparameters = "", PubDate = '';

export class ManualsComponent extends Component {
    displayName = ManualsComponent.name
    constructor(props) {
        super(props);
        this.state = { //this is a temporary fix for hiding/showing links if not logged in -  condition will be modified
            login: false, OnlinePrice: '', Subscribed: false,
            printedmaterial: '',
            PdfPrice: '',
            user: '', TopicId: '', TopicName: '', newcurrency: '', BulletPoint1: '', BulletPoint2: '', BulletPoint3: '', Publishedyear: '', PublicationMon: '', Reviewedyear: '', ReviewedMon: ''
        }

        this.state = {
            email: 'dawn.danish@wolterskluwer.com',
        };

        this.state = {
            checked: false,
            checked1: true,
            manualTitle: [],
            manualImage: [],
            manualDesc: [],
            manualMainEditors: [],
            manualSubTitle: [],
            manualEditors: [],
            manualAbout: [],
            manualAuthorGuidelines: [],
            whatsNew: [],
            tocLevel1: [],
            tocLevel2: [],
            tocLevel3: [],
            tocLevel4: [],
            tocLevel5: [],
            tocLevel2List: "",
            productprice: [],
            link: '',
            code: '',
            samplePDF: [],
            emailReciepient: '', metaDescription: '', metaTitle: '', ShowSublist: [], emailRec: '', emailName: '',
            redirectToLogin: false

        }
        this.onChange = this.onChange.bind(this);
        this.onChange1 = this.onChange1.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        //this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleChapterModalShow = this.handleChapterModalShow.bind(this);
        this.handleChapterModalClose = this.handleChapterModalClose.bind(this);
        this.sendEmail = this.sendEmail.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.HandleClick = this.HandleClick.bind(this);
        this.HandleIClick = this.HandleIClick.bind(this);
        this.GetSubLevels = this.GetSubLevels.bind(this);
        this.handleEmailModalShow = this.handleEmailModalShow.bind(this);
        this.handleEmailModalClose = this.handleEmailModalClose.bind(this);
        this.sendShareByEmail = this.sendShareByEmail.bind(this)
        //this.DownArrowToggle = this.DownArrowToggle.bind(this);
        this.handleEmailValidation = this.handleEmailValidation.bind(this);
        this.BindSIQEvent = this.BindSIQEvent.bind(this);
        this.logoutsession = this.logoutsession.bind(this);
        this.handleEtocModalShow = this.handleEtocModalShow.bind(this);
        this.handleEtocModalClose = this.handleEtocModalClose.bind(this);

    }
    handleEtocModalClose() {
        this.setState({ handleEtocModalShow: false });
    }

    handleEtocModalShow() {
        this.setState({ handleEtocModalShow: true });
    }
    logoutsession() {

        var self = this;
        if (localStorage.getItem('user') !== null) {
            appService.getAll('/User/logOutDecreseActiveCount').then(function (response) {
                appService.getAll('/User/logOut').then(function (response) {

                    //localStorage.removeItem('user');
                    //localStorage.removeItem('userId');
                    //localStorage.removeItem('usersubscription');
                    //localStorage.removeItem('company');
                    //localStorage.removeItem('firstName');
                    //localStorage.removeItem('lastName');
                    //localStorage.removeItem('salesForceID');
                    localStorage.clear();
                    localStorage.setItem('logoutclick', 'true');

                });
                window['LastURL'] = '';
            });

        }
        self.setState({
            redirectToLogin: true
        })
    }
    BindSIQEvent(key) {        

        var prdTitle = typeof this.props.match.params.title != "undefined" ? this.props.match.params.title.replace(/\+/g, " ") : "";

        if (key == "Manual contents") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=table of contents&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + this.state.Subscribed + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=table of contents&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&Subscribed=false' + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

        if (key == "About manual") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=abstract&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + this.state.Subscribed + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=abstract&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&Subscribed=false' + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
        }

        if (key == "Editors") {
                if (localStorage.getItem('user') !== null) {
                    window['NTPT_PGEXTRA'] = 'event_type=all_editors&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + this.state.Subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
                else {
                    window['NTPT_PGEXTRA'] = 'event_type=all_editors&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&Subscribed=false' + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
            }

        if (key == "AuthorGuide") {
                if (localStorage.getItem('user') !== null) {
                    window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + this.state.Subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
                else {
                    window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&Subscribed=false' + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
        }

        if (key == "Announcements") {
            if (localStorage.getItem('user') !== null) {
                window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + this.state.Subscribed + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
            else {
                window['NTPT_PGEXTRA'] = 'event_type=author_guidelines&ProductId=' + this.props.match.params.id + '&ProductTitle=' + prdTitle + '&Subscribed=false' + '&platform=klo&useragent=' + useragent;
                const script = document.createElement("script");
                script.src = "/siqpagetag.js";
                script.async = true;
                document.body.appendChild(script);
            }
    }
            var msg = {
                ArticleTitle: window['NTPT_PGEXTRA']
            }
            var Logurl = 'Product/LogData';
            appService.submit(Logurl, msg).then(function (data) {

            });

    }

    handleEmailValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["email"].value;

        if (emailTo == "") {
            formIsValid = false;
            this.state.emailRec = "* Required field";
        }

        if (emailTo != "") {
            var emails = emailTo.split(";");
            emails.forEach(function (emails) {
                let lastAtPos = emails.lastIndexOf('@');
                let lastDotPos = emails.lastIndexOf('.');

                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emails.indexOf('@@') == -1 && lastDotPos > 2 && (emails.length - lastDotPos) > 2)) {
                    formIsValid = false;
                    self.state.emailRec = "* Please enter a valid email address";
                }
            })
        }
        self.setState({ errors: errors });

        return formIsValid;

    }

    sendShareByEmail() {
        if (this.handleEmailValidation()) {
            this.state.emailRec = '';
            Emailparameters = {
                Email: this.refs["email"].value,
                Subject: this.refs["SubjectTitle"].value == "" ? this.state.manualTitle : this.refs["SubjectTitle"].value,
                Category: window.location.href,
                AdditionalInfo: this.refs["AddInfo"].value
            }
            var self = this;

            appService.submit('/Email/ShareByEmail', Emailparameters)
                .then(function (data) {
                    if (data == "Success") {
                        self.setState({ handleEmailModalShow: false });
                    }
                });
        }
    }

    componentDidMount() {
        //Pradip Lalvani
        if (localStorage.getItem('user') !== null) {
            this.state.login = true;
        }
        else {
            this.state.login = false;
        }

        this.state.user = JSON.parse(localStorage.getItem('user')); //Pradip Lalvani

        if (this.props.match.params.title) {
            if (this.props.match.params.title.includes(" ")) {
                var titlep = this.props.match.params.title.replace(/ /g, "+");
                window.location.href = 'Manuals/' + titlep + '/' + this.props.match.params.id;
            }
        }

        ProductId = document.location.pathname.split('/')[3];

        var self = this;
        parameters = { ProductId: ProductId, user: this.state.user }; //Pradip Lalvani};
        appService.getByIssueId('Product/GetManual', parameters)
            .then(function (data) {
                //console.log(data);
                if (data == "Error found") {
                    //window.location = "/Maintenance";;
                }
                self.setState({ samplePDF: data.samplePDF });
                self.setState({ manualTitle: data.title });
                self.setState({ manualImage: data.imageUrl });
                self.setState({ Subscribed: data.subscribed }) //Pradip Lalvani
                self.setState({ manualDesc: data.description });
                self.setState({ manualMainEditors: data.mainEditors });
                self.setState({ manualSubTitle: data.subTitle });
                self.setState({ manualEditors: data.editors });
                self.setState({ whatsNew: data.whatsNew });
                self.setState({ manualAbout: data.aboutManual });
                self.setState({ manualAuthorGuidelines: data.authorGuidelines });
                self.setState({ tocLevel1: data.toclevel1 });
                self.setState({ TopicId: data.topicId });
                self.setState({ TopicName: data.topic });
                self.setState({ code: data.code });
                self.setState({ metaTitle: data.metaTitle });
                self.setState({ metaDescription: data.metaDescription });
                self.setState({ BulletPoint1: data.bulletPoint1 });
                self.setState({ BulletPoint2: data.bulletPoint2 });
                self.setState({ BulletPoint3: data.bulletPoint3 });
               
                let lastid = self.state.ShowSublist;
                data.toclevel1.map((items) => {
                    if (items.name !== "General Section") {
                        lastid.push(items.id + "_" + items.name);
                        self.setState({
                            ShowSublist: lastid
                        })
                    }

                })
                
                //self.setState({ productprice: data.productPrice });

                //fetch("https://ipapi.co/json/")
                //    .then(res => res.json())
                //    .then(
                //    (result) => {
                //        //console.log(result)
                //        self.setState({ newcurrency: result.currency });

                //        self.state.productprice.map((item) => {

                //            //console.log(item);
                //            if (self.state.newcurrency == "EURO" || self.state.newcurrency == "INR" || self.state.newcurrency == '') {

                //                if (item != null && item.type == "2") {
                //                    self.setState({ OnlinePrice: item.euro });
                //                }
                //                if (item != null && item.type == "3") {
                //                    self.setState({ printedmaterial: item.euro });
                //                }
                //                if (item != null && item.type == "1") {
                //                    self.setState({ PdfPrice: item.euro });
                //                }
                //            }
                //            else if (self.state.newcurrency == "POUND") {

                //                if (item != null && item.type == "2") {
                //                    self.setState({ OnlinePrice: item.pound });
                //                }
                //                if (item != null && item.type == "3") {
                //                    self.setState({ printedmaterial: item.pound });
                //                }
                //                if (item != null && item.type == "1") {
                //                    self.setState({ PdfPrice: item.pound });
                //                }
                //            }
                //            else {

                //                if (item != null && item.type == "2") {
                //                    self.setState({ OnlinePrice: item.usd });
                //                }
                //                if (item != null && item.type == "3") {
                //                    self.setState({ printedmaterial: item.usd });
                //                }
                //                if (item != null && item.type == "1") {
                //                    self.setState({ PdfPrice: item.usd });
                //                }
                //            }
                //        }
                //        )
                //        });

                parameters = { toclevelid: data.toclevel1[data.toclevel1.length - 1].id, productid: ProductId };

                var prdTitles = typeof self.props.match.params.title != "undefined" ? self.props.match.params.title.replace(/\+/g, " ") : "";

                if (localStorage.getItem('user') !== null) {
                    window['NTPT_PGEXTRA'] = 'event_type=table of contents&ProductId=' + self.props.match.params.id + '&ProductTitle=' + prdTitles + '&user_id=' + localStorage.getItem('salesForceID') + '&User=' + localStorage.getItem('user') + '&Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
                else {
                    window['NTPT_PGEXTRA'] = 'event_type=table of contents&ProductId=' + self.props.match.params.id + '&ProductTitle=' + prdTitles + '&User= &Subscribed=' + data.subscribed + '&platform=klo&useragent=' + useragent;
                    const script = document.createElement("script");
                    script.src = "/siqpagetag.js";
                    script.async = true;
                    document.body.appendChild(script);
                }
                var msg = {
                    ArticleTitle: window['NTPT_PGEXTRA']
                }
                var Logurl = 'Product/LogData';
                appService.submit(Logurl, msg).then(function (data) {

                });
                ReactGA.initialize(
                    [
                        {
                            trackingId: 'UA-2905701-8',
                            gaOptions: { name: 'tracker1' }
                        },
                        {
                            trackingId: 'UA-72849501-2',
                            gaOptions: { name: 'tracker2' }
                        }
                    ],
                    { alwaysSendToDefaultTracker: false }
                );

                ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'],data.title + " - Kluwer Law Online");
                var metas = document.getElementsByTagName('meta');
                for (let i = 0; i < metas.length; i++) {
                    if (metas[i].getAttribute('name') == "robots") {
                        console.log(metas[i]);
                        metas[i].remove();
                    }
                }
            });
    }

    handleChapterModalClose() {
        this.setState({ handleChapterModalShow: false });
    }

    async handleChapterModalShow() {

        if (this.state.checked == false && this.state.checked1 == false) {
            alert('Please choose your subscription ');
        }
        else {

            const requestOptionsCountry = {

                headers: authHeader(),

            };

            const response = await fetch("https://ipapi.co/json/", requestOptionsCountry);
            const json = await response.json();
            this.setState({ currency: json.currency });

            const requestOptions = {
                method: 'POST',
                headers: authHeader(),
                body: {},
            };
            //url = this.props.location.search;
            //if (this.props.match.params.id) {
            //    ProductId = this.props.match.params.id
            //}
            //else {
            //    params = queryString.parse(url);
            //    ProductId = params.Id;
            //}
            let ProductId = document.location.pathname.split("/")[3];
            // params = queryString.parse(url);
            var self = this;
            fetch(config.apiUrl + '/Cart/AddToCart?IsProductId=true&ProductId=' + ProductId + '&OnlineThreeMonthsDelivery=' + this.state.checked + '&PrintDelivery=' + this.state.checked1 + '&currency=' + this.state.currency, requestOptions).then(function (data) {

                self.setState({ handleChapterModalShow: true });
            });
        }
    }

    handleSelect() {
        window.scrollTo(0, 0);
        
    }

    handleClose() {
        this.setState({ show: false });
    }
    handleShow(e) {
        fileName = "Manuals\\" + this.state.code + "\\" + e;
        this.setState({ show: true });
    }
    onChange(e) {
        this.setState({ 'checked': e.target.checked });
    }

    onChange1(e) {
        this.setState({ 'checked1': e.target.checked });
    }

    sendEmail() {
        localStorage.setItem('link', JSON.stringify(window.location.href));
        window.scrollTo(0, 0);
    }

    handleEmailModalClose() {
        this.setState({ handleEmailModalShow: false });
    }

    handleEmailModalShow() {
        this.setState({ handleEmailModalShow: true });
    }

    HandleClick(e) {
        //console.log(e.target);
        if (this.state.ShowSublist.some(item => e.target.id === item)
            //&& newel[0].className == "fa fa-chevron-down"
        ) {

            let index = this.state.ShowSublist.indexOf(e.target.id);
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };

        }
        else {
            let options = this.state.ShowSublist;
            options.push(e.target.id);

            this.setState({
                ShowSublist: options
            })

        }

    }

    HandleIClick(e) {
        if (this.state.ShowSublist.some(item => e.target.id === item) &&
            e.target.className === "fa fa-minus") {

            let index = this.state.ShowSublist.indexOf(e.target.id);
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };
            e.target.className = "fa fa-plus";
        }
        else {
            let options = this.state.ShowSublist;
            options.push(e.target.id);

            this.setState({
                ShowSublist: options
            })
            e.target.className = "fa fa-minus";

        }

    }

    GetSubLevels(e) {
        if (this.state.ShowSublist.some(item => e.target.id === item)) {

            let index = this.state.ShowSublist.indexOf(e.target.id);
            if (index > -1) {
                this.state.ShowSublist.splice(index, 1);
                this.setState({ ShowSublist: this.state.ShowSublist });
            };
          //  e.target.className = "fa fa-plus";
        }
        else {
            let options = this.state.ShowSublist;
            options.push(e.target.id);

            this.setState({
                ShowSublist: options
            })
          //  e.target.className = "fa fa-minus";

        }

    }


    renderTocLevel1List = () => {

        return this.state.tocLevel1.map((item, index) =>
            <div>
                {
                    index !== 0 ?
                        <br></br>
                        :
                        null
                }
                <div style={accordion} onClick={this.HandleClick} id={item.id + "_" + item.name}>
                    <span style={AccordionTitle}>{item.name}</span>
                    {
                        item.toclevel2.length > 0 && item.toclevel2 !== null ?
                            this.state.ShowSublist.indexOf(item.id + "_" + item.name) > -1 ?
                                <i style={{ fontSize: '25px', float: 'right', color: 'lightgrey', marginRight: '5px', zindex: '1', position: 'relative' }}
                                    className="fa fa-chevron-up"></i>
                                :
                                <i style={{ fontSize: '25px', float: 'right', color: 'lightgrey', marginRight: '5px', zindex: '1', position: 'relative' }}
                                    className="fa fa-chevron-down"></i>
                            :
                            null
                    }

                </div>
                <div style={{ borderLeft: '1px solid #CCCCCC', borderRight: '1px solid #CCCCCC', borderBottom: '1px solid #CCCCCC' }}>
                    {this.state.ShowSublist.indexOf(item.id + "_" + item.name) > -1 ?
                        item.toclevel2.map(tocitem =>
                            <div style={Marginset}>

                                {
                                    tocitem.toclevel3.length > 0 && tocitem.toclevel3 !== null ?
                                        <div>
                                            <i style={{ fontSize: '15px', color: '#007AC3', paddingLeft: '2%' }}
                                                className={this.state.ShowSublist.indexOf(tocitem.id + "_" + tocitem.name + "_" + item.name) > -1 ? "fa fa-minus" : "fa fa-plus"}
                                                id={tocitem.id + "_" + tocitem.name + "_" + item.name}  onClick={this.HandleIClick}></i>
                                            <span onClick={this.GetSubLevels} id={tocitem.id + "_" + tocitem.name + "_" + item.name} className="LinkClass" style={{ marginLeft: '1%', display: 'inline-block', cursor: 'pointer' }}>{tocitem.name}</span>
                                        </div>
                                        :
                                        <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocitem.docId} className="LinkClass" style={{ marginLeft: '2%', display: 'inline-block' }}> {tocitem.name}</Link>
                                }

                                {this.state.ShowSublist.indexOf(tocitem.id + "_" + tocitem.name + "_" + item.name) > -1 ?
                                    tocitem.toclevel3.map(tocSitem =>
                                        <div>
                                            {
                                                tocSitem.toclevel4.length > 0 && tocSitem.toclevel4 !== null ?
                                                    <div>
                                                        <i style={{ fontSize: '15px', color: '#007AC3', paddingLeft: '5%' }}
                                                            className={this.state.ShowSublist.indexOf(tocSitem.id + "_" + tocSitem.name + "_" + tocitem.name) > -1 ? "fa fa-minus" : "fa fa-plus"}
                                                            id={tocSitem.id + "_" + tocSitem.name + "_" + tocitem.name} onClick={this.HandleIClick}></i>
                                                        <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocSitem.docId} className="LinkClass" style={{ marginLeft: '1%', display: 'inline-block' }}>{tocSitem.name}</Link>
                                                    </div>
                                                    :
                                                    <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocSitem.docId} className="LinkClass" style={{ marginLeft: '7%', display: 'inline-block' }}>{tocSitem.name}</Link>
                                            }

                                            {this.state.ShowSublist.indexOf(tocSitem.id + "_" + tocSitem.name + "_" + tocitem.name) > -1 ?
                                                tocSitem.toclevel4.map(tocSEitem =>
                                                    <div>
                                                      
                                                        {
                                                            tocSEitem.toclevel5.length > 0 && tocSEitem.toclevel5 !== null ?
                                                                <div>
                                                                    <i style={{ fontSize: '15px', color: '#007AC3', paddingLeft: '8%' }}
                                                                        className={this.state.ShowSublist.indexOf(tocSEitem.id + "_" + tocSEitem.name + "_"+tocSitem.name) > -1 ? "fa fa-minus" : "fa fa-plus"}
                                                                        id={tocSEitem.id + "_" + tocSEitem.name + "_" + tocSitem.name} onClick={this.HandleIClick}></i>
                                                                    <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocSEitem.docId} className="LinkClass" style={{ marginLeft: '1%', display: 'inline-block' }}>{tocSEitem.name}</Link>
                                                                </div>
                                                                :
                                                                <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocSEitem.docId} className="LinkClass" style={{ marginLeft: '9%', display: 'inline-block' }}>{tocSEitem.name}</Link>
                                                        }
                                                       
                                                        {this.state.ShowSublist.indexOf(tocSEitem.id + "_" + tocSEitem.name + "_" + tocSitem.name) > -1 ?
                                                            tocSEitem.toclevel5.map(tocSECitem =>
                                                                <Link onClick={this.handleSelect} to={"/ManualChapter/" + this.state.manualTitle.replace(/ /g, "+") + "/" + tocSECitem.docId} className="LinkClass" style={{ marginLeft: '11%', display: 'inline-block' }}>{tocSECitem.name}</Link>
                                                            )
                                                            :
                                                            null

                                                        }
                                                    </div>
                                                )
                                                :
                                                null
                                            }
                                        </div>
                                    )
                                    :
                                    null
                                }
                            </div>

                        )
                        :
                        null}
                </div>
            </div>
        )
    }

    //Start:Pradip Lalvani -New
    handleValidation() {
        var self = this;
        let fields = self.state.fields;
        let errors = {};
        let formIsValid = true;

        var emailTo = this.refs["emailTo"].value;
        var emailName = this.refs["emailName"].value;

        if (emailName == "") {
            formIsValid = false;
            this.state.emailName = "* Required field";
        }
        else {
            this.state.emailName = "";
        }
        //var Body = this.refs["Body"].value;
        if (emailTo == "") {
            formIsValid = false;
            this.state.emailReciepient = "* Required field";
        }
        
        if (emailTo != "") {
            let lastAtPos = emailTo.lastIndexOf('@');
            let lastDotPos = emailTo.lastIndexOf('.');

            if (!(lastAtPos < lastDotPos && lastAtPos > 0 && emailTo.indexOf('@@') == -1 && lastDotPos > 2 && (emailTo.length - lastDotPos) > 2)) {
                formIsValid = false;
                this.state.emailReciepient = "* Please enter a valid email address";
            }
        }

        self.setState({ errors: errors });
        if (!formIsValid) {
            window.scrollTo({
                top: 200,
                behavior: 'smooth',
            });
            return false;
        }

        return true;
    }
    handleSubmit(event) {
        event.preventDefault();
        var self = this;
        if (self.handleValidation()) {
            this.state.emailName = '';
            this.state.emailReciepient = '';
            var emailTo = this.refs["emailTo"].value;
            var Body = 'Dear ' + this.refs["emailName"].value + ",";
            var Subject = this.state.Subject;
            var isNotForLink = true;

            parameters = { To: emailTo, Body: Body, Subject: Subject, isNotForLink: isNotForLink, FileName: fileName };

            appService.getByIssueId('/Email/SendEmail', parameters)
                .then(function (data) {
                    if (data == "Success") {
                        window.location = "/ThankyouSubscription";
                    }
                });
        }
        else {
            return false;
        }
        this.setState({ show: false });
    }
    //End:Pradip Lalvani -New

    render() {
        if (this.state.redirectToLogin) {
            this.setState({ redirectToLogin: false });
            return <Redirect to={"/Login"} />
        }
        const renderSamplePDF = this.state.samplePDF !== undefined && Object.entries(this.state.samplePDF).map((item, index) => {
            var docName = "Sample section";
            return <div className="TopicBorder" id="Samplearticle">
                <br></br>
                <p className="paddingL" style={{ margin: '0' }}>
                    <a className="LinkClass margintop HoverUnderline" style={{ cursor: 'pointer' }} onClick={(e) => this.handleShow(item[1].fileName)} dangerouslySetInnerHTML={{ __html: item[1].articleTitle }}></a> (PDF)
                        </p><br></br>
            </div>

        })

        const meta = {
            title: this.state.manualTitle + " - Kluwer Law Online",
           // description: this.state.metaDescription,
            canonical: window.location.href,
            //meta: {
            //    charset: "utf-8",
            //    name: {
            //        citation_title: this.state.manualTitle,
            //        citation_main_editors: this.state.manualMainEditors,
            //        citation_number: this.props.match.params.id,
            //        title: this.state.metaTitle,
            //        description: this.state.metaDescription
            //    }
            //}
        }

        return (
            <DocumentMeta {...meta}>
                <div>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-9">
                                    <p className="TitlePadding"><Link to="/" className="LinkClass">Home</Link> > <Link to="/AllManuals" className="LinkClass" > All manuals</Link> > <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: this.state.manualTitle }}></div></p>
                            </div>
                        </div>
                        <div className="row AllColPadding margintop">
                            <div className="row" style={{ width: '100%' }}>
                                <div className="col-lg-8" style={{ minWidth: '73%' }}>
                                    <div className="JournalFlex">
                                        <img alt={"Cover Image for " + this.state.manualTitle} src={"/../../images/books/" + this.state.manualImage} className="TitleImg" />
                                        <div style={{ width: '100%' }}>
                                            <h1 className="paddingL PublicationTitle">
                                                <span className="PublicationTitle"><div dangerouslySetInnerHTML={{ __html: this.state.manualTitle }}></div></span> </h1>
                                            <p className="paddingL">
                                                <div dangerouslySetInnerHTML={{ __html: this.state.manualSubTitle }} className="ManualSubTitleText"></div>
                                                <div dangerouslySetInnerHTML={{ __html: this.state.manualMainEditors }}></div>
                                             
                                            </p>
                                            <p className="paddingL">
                                                <ul className="ManualUl" style={{ paddingLeft: '3%' }}>
                                                    {this.state.BulletPoint1 !== null && this.state.BulletPoint1 !== '' ?
                                                        <li dangerouslySetInnerHTML={{ __html: this.state.BulletPoint1 }}></li>
                                                        :
                                                        null
                                                    }
                                                    {this.state.BulletPoint2 !== null && this.state.BulletPoint2 !== '' ?
                                                        <li dangerouslySetInnerHTML={{ __html: this.state.BulletPoint2 }}></li>
                                                        :
                                                        null
                                                    }
                                                    {this.state.BulletPoint3 !== null && this.state.BulletPoint3 !== '' ?
                                                        <li dangerouslySetInnerHTML={{ __html: this.state.BulletPoint3 }}></li>
                                                        :
                                                        null
                                                    }
                                                </ul>
                                            </p>


                                        </div>
                                    </div>
                                    <div className="White"></div>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <Tabs className="flex-tabs Tabfont myClass" defaultActiveKey="Manual contents" id="uncontrolled-tab-example" onSelect={this.BindSIQEvent}>
                                                <Tab eventKey="Manual contents" title="Manual contents">
                                                    <div className="White"></div>
                                                    {this.renderTocLevel1List()}
                                                </Tab>
                                                <Tab eventKey="About manual" title="About manual">
                                                    <br></br>
                                                    <p className="BookBody">
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.manualAbout }}></div>
                                                    </p>
                                                </Tab>
                                                <Tab eventKey="Editors" title="Editors">
                                                    <br></br>
                                                    <p className="BookBody">
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.manualEditors }}></div>
                                                    </p>
                                                </Tab>
                                                <Tab eventKey="AuthorGuide" title="Author guidelines">
                                                    <br></br>
                                                    <p className="BookBody">
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.manualAuthorGuidelines }}></div>
                                                    </p>
                                                </Tab>
                                                {this.state.whatsNew !== null &&
                                                this.state.whatsNew !== "" ? (
                                                <Tab eventKey="Announcements" title="Announcements">
                                                    <br></br>
                                                    <p className="BookBody">
                                                        <div dangerouslySetInnerHTML={{ __html: this.state.whatsNew, }}></div>
                                                    </p>
                                                </Tab>
                                                ) : null}
                                                
                                            </Tabs>
                                            <div className="White"></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-3">
                                    {(!this.state.login && !this.state.Subscribed) || (this.state.login && !this.state.Subscribed) ? /*Pradip Lalvani*/
                                        <div>
                                            <div className="TopicBorder BGGrey" id="Subcribeto" style={{ borderTop: '2px solid #CCCCCC', paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                                <span className="paddingL fontbold margintop SetPaddingforP"> Subscribe to this manual </span>
                                            </div>
                                            <div className="TopicBorder" id="Pricemenu">
                                                <p className="paddingL fontbold" style={{ lineHeight: '3', marginBottom: '3%'}}>Interested in a subscription?
                                                    <Link to="/ContactSales" variant="secondary" style={{ marginTop: '3%', textAlign: 'center' }} className="Modalbutton Setwdth HoverUnderline">  <strong> Contact our sales team</strong> </Link>
                                                </p>
                                            </div>
                                            {
                                                this.state.samplePDF !== undefined && this.state.samplePDF.length > 0 ?
                                                <div>
                                                    <div className="TopicBorder BGGrey" id="Takealook" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                                        <span className="paddingL fontbold margintop SetPaddingforP"> Sample content </span>
                                                    </div>
                                                    {renderSamplePDF}
                                                </div>
                                                :
                                                null
                                            }
                                        </div>
                                        : null}
                                    <Modal show={this.state.show} onHide={this.handleClose}  {...this.props}
                                        size="md"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <Modal.Header closeButton className="Popupcolor">
                                            <Modal.Title>Sample content</Modal.Title>
                                        </Modal.Header>
                                        <Modal.Body>
                                            <div className="col-8">
                                                <label htmlFor="Name">Name</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" ref="emailName" placeholder="Enter your name" id="Name" />
                                                <span className="error">{this.state.emailName}</span>
                                            </div>
                                            <br></br>
                                            <div className="col-8">
                                                <label htmlFor="Email">Email</label>
                                                <input type="text" className="form-control form-control-sm rounded-0" ref="emailTo" placeholder="Enter your email" id="Email" />
                                                <span className="error">{this.state.emailReciepient}</span>
                                            </div>
                                            <br></br>
                                            <div className="col-8">
                                                <a href="http://www.kluwerlaw.com/terms-and-conditions/" target="_blank">Terms and Conditions</a>
                                            </div>
                                        </Modal.Body>
                                        <Modal.Footer>
                                            <div className="row">
                                                <div className="col" style={{ paddingLeft: '6%' }}>
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleClose}>  Return to site </span>
                                                </div>
                                                <div className="col TopicPadding">

                                                    <button type="button" className="btn btn-info next rounded-0" onClick={this.handleSubmit}>Submit</button>

                                                </div>
                                            </div>
                                        </Modal.Footer>
                                    </Modal>
                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Browse by practice area  </span>
                                    </div>
                                    <div className="TopicBorder">
                                        <br></br>
                                        {this.state.TopicName !== undefined ?
                                            <Link to={"/PracticeArea?Id=" + this.state.TopicId + "&name=" + this.state.TopicName.replace(/ /g, "+")} onClick={this.handleSelect} className="paddingL LinkClass margintop" style={this.state.TopicName.length > 33 ? Displaystyle : null}>{this.state.TopicName} </Link>
                                            :
                                            null
                                        }
                                        <br></br> <br></br>
                                    </div>
                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Share </span>
                                    </div>
                                    <div className="TopicBorder fontbold">
                                        <br></br>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on Linkedin"
                                                title="Share on Linkedin" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href + "&title=&summary=&source="}
                                                    target="_blank">
                                                    <i class="fa fa-linkedin shareicons colPadding btn-fa" aria-hidden="true"></i></a>
                                            </span>
                                        </CopyToClipboard>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on X" className="RSSCard Shareicon-margin" >
                                                <a href={"https://X.com/home?status=" + window.location.href} target="_blank" title="Share on X">
                                                    <b
                                                        class="shareicon-X colPadding btn-fa"
                                                        aria-hidden="true"
                                                    >𝕏</b>
                                                </a>
                                            </span>
                                        </CopyToClipboard>
                                        <CopyToClipboard text={document.location.href}>
                                            <span data-tooltip="Share on Facebook" className="RSSCard Shareicon-margin" >
                                                <a href={"https://www.facebook.com/sharer/sharer.php?u=" + window.location.href}
                                                    target="_blank" title="Share on Facebook">
                                                    <i class="fa fa-facebook shareicon-facebook colPadding btn-fa" aria-hidden="true"></i></a>
                                            </span>
                                        </CopyToClipboard>
                                        {/* <span onClick={this.handleEmailModalShow} className="RSSCard Shareicon-margin" data-tooltip="Share by Email">
                                            <i class="fa fa-envelope shareicons colPadding btn-fa" aria-hidden="true"></i>
                                        </span> */}
                                        <br></br>
                                        <br></br>
                                    </div>
                                    <EmailModal show={this.state.handleEmailModalShow} onHide={this.handleEmailModalClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <EmailModal.Header closeButton className="Popupcolor">
                                            <Modal.Title>
                                                Share by email
                                            </Modal.Title>
                                        </EmailModal.Header>
                                        <EmailModal.Body>
                                            <div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="To">To</label>
                                                        <input type='email' id="email" name="email" ref="email" className="form-control form-control-sm rounded-0"
                                                            placeholder="Enter your email address(es); separated by semi-colon" />
                                                        <span className="error">{this.state.emailRec}</span>
                                                    </div>
                                                </div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="SubjectTitle">Subject</label>
                                                        <input type="text" ref="SubjectTitle" className="form-control form-control-sm rounded-0" placeholder={this.state.manualTitle} id="SubjectTitle" name="SubjectTitle" />
                                                    </div>
                                                </div>
                                                <div className="row mt-3 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label for="URL" style={{ fontSize: '12px' }}>{window.location.href}</label>
                                                        <textarea
                                                            className="form-control"
                                                            id="addInfo"
                                                            name="addInfo"
                                                            rows="3" placeholder="Enter message" ref="AddInfo"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </EmailModal.Body>
                                        <EmailModal.Footer>
                                            <div className="row AllColPadding">
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEmailModalClose}>  Return to site </span>
                                                </div>
                                                <div className="col-sm-4 TopicPadding">
                                                    <button variant="primary" className="btn btn-info next FloatSet" onClick={this.sendShareByEmail}>
                                                        Submit
                                    </button></div>
                                            </div>
                                        </EmailModal.Footer>
                                    </EmailModal>


                                    <div className="TopicBorder BGGrey" style={{ paddingBottom: '3%', paddingTop: '3%', fontSize: '18px' }}>
                                        <span className="paddingL fontbold margintop SetPaddingforP"> Stay up to date </span>
                                    </div>
                                    <div className="TopicBorder" style={{ paddingBottom: '3%' }}>
                                        <br></br>
                                        <a className="LinkClass RSSCard Shareicon-margin" style={{ cursor: 'pointer' }} href={'feeds/' + this.state.code} target="_blank" title="Open RSS feed" data-tooltip="RSS feed for this title">
                                            <i class="fa fa-rss shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i> 
                                        </a>
                                        <Link to="/Etoc" onClick={this.handleSelect} className="RSSCard Shareicon-margin" data-tooltip="Table of contents alert for this title"
                                            title="Table of contents alert for this title">
                                            <i class="fa fa-clock-o shareicon-ETOC colPadding btn-fa" aria-hidden="true"></i>
                                        </Link>
                                        <br></br>
                                        <span style={{ fontSize: '11px', color: '#757575', marginLeft: '7%' }}>RSS</span>
                                        <span style={{ fontSize: '11px', color: '#757575', marginLeft: '13%' }}>ETOC</span>
                                        <br></br>
                                    </div>
                                    <EmailModal show={this.state.handleEtocModalShow} onHide={this.handleEtocModalClose}  {...this.props}
                                        size="lg"
                                        aria-labelledby="contained-modal-title-vcenter"
                                        centered>
                                        <EmailModal.Header closeButton className="Popupcolor">
                                            <Modal.Title>
                                                Table of Contents alert (ETOC)
                                            </Modal.Title>
                                        </EmailModal.Header>
                                        <EmailModal.Body>
                                            <div>
                                                <div className="row mt-6 AllColPadding">
                                                    <div className="col-lg-6 TopicPadding">
                                                        <label>Sign up for ETOC alerts to receive an e-mail informing you when new content for Kluwer Law Online prodcuts is available online. Login or create an account and select the title(s) you wish to subscribe to.</label>

                                                    </div>
                                                </div>

                                            </div>
                                        </EmailModal.Body>
                                        <EmailModal.Footer>
                                            <div className="row AllColPadding">

                                                <div className="col-sm-4 TopicPadding">

                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.logoutsession}>  Login/Create Account </span>
                                                </div>
                                                <div className="col-sm-8 TopicPadding ">
                                                    <span variant="secondary" className="Modalbutton HoverUnderline" onClick={this.handleEtocModalClose}>  Return to site </span>
                                                </div>
                                            </div>
                                        </EmailModal.Footer>
                                    </EmailModal>
                                </div>
                            </div>
                        </div>
                        <div className="White">
                        </div>
                    </div>
                </div >
            </DocumentMeta>

        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Manuals/ManualsComponent.jsx